<template>
    <div class="app">
        <div class="box">
            <div class="left">
                <div class="title">学生未到校情况增长趋势</div>
                <div style="height:100%;width:100%" ref="student"></div>
            </div>
            <div class="right">
                <div class="title">预警事件增长趋势</div>
                <div style="height:100%;width:100%" ref="event"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataBoardAttendance, dataBoardWarn } from "@/api/index";
export default {
    data() {
        return {
            student: {
                actual: 0,
                total: 0,
                list: [],
                reason: [],
            },
            teacher: {
                reason: [],
            },
            rising: {
                axis_name: [],
                dispose_value: [],
                undisposed_value: [],
            }
        }
    },
    mounted() {
        this.getList();
        this.getWarn();
    },
    methods: {
        async getList() {
            const res = await this.axios.post(dataBoardAttendance);
            if (res.data.code == 1) {
                this.student = res.data.data.student;
                this.teacher = res.data.data.teacher;
                this.getStudent();
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        async getWarn() {
            const res = await this.axios.post(dataBoardWarn);
            if (res.data.code == 1) {
                this.rising = res.data.data.rising;
                this.getEvent();
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        getEvent() {
            const chart = this.$refs.event;
            const myChart = this.$echarts.init(chart);
            const option = {
                legend: {
                    data: ['已处理事件', '未处理事件'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    // trigger: 'axis',
                    // axisPointer: {
                    //     type: 'cross',
                    //     crossStyle: {
                    //         color: '#999'
                    //     }
                    // }
                },
                color: ['#03a3ad', '#e9533c'],
                xAxis: {
                    type: 'category',
                    data: this.rising.axis_name,
                    axisLabel: {
                        interval: 0,  //0：表示全部显示不间隔；auto:表示自动根据刻度个数和宽度自动设置间隔个数
                        formatter: function (value)  //X轴的内容
                        {
                            var ret = ""; //拼接加\n返回的类目项
                            var max = 5;  //每行显示的文字字数
                            var val = value.length;  //X轴内容的文字字数
                            var rowN = Math.ceil(val / max);//需要换的行数
                            if (rowN > 1)  //判断 如果字数大于2就换行
                            {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = ""; //每次截取的字符串
                                    var start = i * max;  //开始截取的位置
                                    var end = start + max;  //结束截取的位置
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp;  //最终的字符串
                                }
                                return ret;
                            }
                            else { return value }
                        }
                    },
                },
                yAxis: {
                    minInterval: 1,
                    axisLabel: {
                        formatter: '{value} 个',
                    }
                },
                series: [
                    {
                        name: '已处理事件',
                        type: 'bar',
                        barWidth: '40%',
                        data: this.rising.dispose_value,
                    },
                    {
                        name: '未处理事件',
                        type: 'bar',
                        barWidth: '40%',
                        data: this.rising.undisposed_value,
                    },
                    {
                        name: '已处理事件',
                        type: 'line',
                        data: this.rising.dispose_value,
                        // tooltip: {
                        //     valueFormatter: function (value) {
                        //         return value + '个';
                        //     }
                        // },

                    },
                    {
                        name: '未处理事件',
                        type: 'line',
                        // tooltip: {
                        //     valueFormatter: function (value) {
                        //         return value + '个';
                        //     }
                        // },
                        data: this.rising.undisposed_value,
                    }
                ]
            }
            myChart.setOption(option)
            window.addEventListener("resize", function () {
                myChart.resize()
            })
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        },
        getStudent() {
            const chart = this.$refs.student;
            const myChart = this.$echarts.init(chart);
            const option = {
                legend: {
                    data: ['学生未到校情况'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    // trigger: 'axis',
                    // axisPointer: {
                    //     type: 'cross',
                    //     crossStyle: {
                    //         color: '#999'
                    //     }
                    // }
                },
                color: ['#e9533c'],
                dataset: {
                    source: this.student.list,
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,  //0：表示全部显示不间隔；auto:表示自动根据刻度个数和宽度自动设置间隔个数
                        formatter: function (value)  //X轴的内容
                        {
                            var ret = ""; //拼接加\n返回的类目项
                            var max = 5;  //每行显示的文字字数
                            var val = value.length;  //X轴内容的文字字数
                            var rowN = Math.ceil(val / max);//需要换的行数
                            if (rowN > 1)  //判断 如果字数大于2就换行
                            {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = ""; //每次截取的字符串
                                    var start = i * max;  //开始截取的位置
                                    var end = start + max;  //结束截取的位置
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp;  //最终的字符串
                                }
                                return ret;
                            }
                            else { return value }
                        }
                    },
                },
                yAxis: {
                    minInterval: 1,
                    axisLabel: {
                        formatter: '{value} 人',
                    }
                },
                series: [
                    {
                        name: '学生未到校情况',
                        type: 'bar',
                        barWidth: '50%',
                    },
                    {
                        name: '学生未到校情况',
                        type: 'line',
                    }
                ]
            }
            myChart.setOption(option)
            window.addEventListener("resize", function () {
                myChart.resize()
            })
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        }
    },
}
</script>

<style lang='scss' scoped>
.app {
    width: 100%;
    height: 100%;
    .box {
        width: 100%;
        height: 100%;
        display: flex;
        // background-color: #21274d;
        .left {
            flex: 1;
            width: 40%;
            height: 100%;
            .title {
                text-align: center;
                color: #fff;
                margin-top: 5px;
            }
        }
        .right {
            flex: 1;
            width: 40%;
            height: 100%;
            .title {
                text-align: center;
                color: #fff;
                margin-top: 5px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataBoard/barChart.vue